import React, { Suspense } from 'react'
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'
import { getMsalPca } from '../services/authentication'

import 'react-tabs/style/react-tabs.css'
import 'rsuite/dist/rsuite.min.css'
import './App.css'

const AuthenticatedApp = React.lazy(() => import('./AuthenticatedApp'))
const UnauthenticatedApp = React.lazy(() => import('./UnauthenticatedApp'))

const App = () => {
  const pca = getMsalPca()

  return (
    <div>
      <MsalProvider instance={pca}>
        <Suspense fallback={<div>Loading...</div>}>
          <AuthenticatedTemplate>
            <AuthenticatedApp />
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <UnauthenticatedApp />
          </UnauthenticatedTemplate>
        </Suspense>
      </MsalProvider>
    </div>
  )
}

export default App
